import { injectStrict } from '@/injection/injectStrict.ts';
import { BroadcastKey } from '@/injection/keys.ts';
import Broadcast from '@/classes/Broadcast.ts';
import {
    AuctionStatusBroadcast, AuctionStatusBroadcastSchema,
    InProgressAuctionBroadcastItem,
    InProgressAuctionsBroadcastSchema,
} from '@/types/auction.type.ts';

class AuctionBroadcaster
{
    private $Broadcast: Broadcast;

    constructor() {
        this.$Broadcast = injectStrict(BroadcastKey);
    }

    public listenInProgressAuctions(callback: (auctions: InProgressAuctionBroadcastItem[]) => void): void
    {
        this.$Broadcast
            .getEcho()
            .join('in_progress-auctions-tick')
            .listen('.actions-tick', (data: any) => {
                const parsedAuctions = InProgressAuctionsBroadcastSchema.parse(data);
                const auctions: InProgressAuctionBroadcastItem[] = parsedAuctions as unknown as InProgressAuctionBroadcastItem[];

                callback(auctions);
            });
    }

    public leaveInProgressAuctions(): void
    {
        this.$Broadcast.getEcho().leave('in_progress-auctions-tick');
    }

    public listenAuctionStatus(callback: (auction: AuctionStatusBroadcast) => void): void
    {
        this.$Broadcast
            .getEcho()
            .join('auction-status')
            .listen('.change-auction-status', (data: any) => {
                const parsedAuction = AuctionStatusBroadcastSchema.parse(data);
                const auction: AuctionStatusBroadcast = parsedAuction as unknown as AuctionStatusBroadcast;

                callback(auction);
            });
    }

    public leaveAuctionStatus(): void
    {
        this.$Broadcast.getEcho().leave('auction-status');
    }
}

export default AuctionBroadcaster;
